import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { WebSessionService } from '@reconcept-platform/shared/authentication';
import { SharedNavigationNavModule } from '@reconcept-platform/shared/navigation/nav';
import { WebModalListenerService } from '@reconcept-platform/shared/ui/core/modal';
import { TextLinkActionComponent } from '@reconcept-platform/shared/ui/standalone/button';
import { FilePreviewComponent } from '@reconcept-platform/shared/ui/standalone/file-preview';
import { ModalContainerComponent } from '@reconcept-platform/shared/ui/standalone/modal';
import { ToastNotificationsComponent } from '@reconcept-platform/shared/ui/standalone/toast-notifications';
import { TourContainerComponent } from '@reconcept-platform/shared/ui/standalone/tour';
import { PageStyleService } from '@reconcept-platform/shared/util';
import { WorkspaceViewerService } from '@reconcept-platform/workspace/data-access';
import { Crisp } from 'crisp-sdk-web';

@Component({
  selector: 'rcw-root',
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    TranslatePipe,
    SharedNavigationNavModule,
    ModalContainerComponent,
    FilePreviewComponent,
    ToastNotificationsComponent,
    TextLinkActionComponent,
    TourContainerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    ::ng-deep {
      rcp-top-nav {
        .logo {
          padding-left: var(--sidebar-padding) !important;
          padding-right: var(--sidebar-padding) !important;

          img {
            width: 100% !important;
          }
        }
      }
    }
  `,
})
export class AppComponent {
  private readonly modalListenerService = inject(WebModalListenerService);
  private readonly pageStyleService = inject(PageStyleService);
  private readonly session = inject(WebSessionService);
  private readonly viewerService = inject(WorkspaceViewerService);

  readonly isStandalone = computed(() => this.pageStyleService.pageStyle() === 'standalone');

  constructor() {
    if (localStorage.getItem('reconcept-portfolio|experimentalDarkMode')) {
      document.body.classList.add('experimentalDarkMode');
    }

    this.modalListenerService.initQueryParamsListener();

    this.viewerService.getViewer().subscribe({
      next: (viewer) => {
        Crisp.configure('36e679f9-8b67-4448-8123-f9964ff8f484');

        if (viewer) {
          // @ts-expect-error TS2345 argument not assignable
          Crisp.user.setEmail(viewer.email);
          Crisp.user.setNickname(viewer.fullName);
        }

        Crisp.chat.onChatOpened(() =>
          Crisp.session.setData({
            user_id: viewer?.id,
            url: window.location.href,
          }),
        );
      },
    });
  }

  logout() {
    this.session.logout();
  }
}
